export const FIND_ALL_PROVINCES_COMPLETED = "location/findAllProvincesCompleted";
export const FIND_MUNICIPALITIES_BY_PROVINCE_COMPLETED = "location/findMunicipalitiesByProvinceCompleted";
export const FIND_PARISHES_BY_MUNICIPALITY_COMPLETED = "location/findParishesByMunicipalityCompleted";